import "./OverviewTab.css";

function OverviewTab({ food }) {
    return (
        <div className="overview-tab">

            <div className="overview-grid">

                <div className="overview-card">

                    <h3>Basic Information</h3>

                    <div className="info-row">
                        <span>Food Name</span>
                        <strong>{food.foodName}</strong>
                    </div>

                    <div className="info-row">
                        <span>Category</span>
                        <strong>{food.category}</strong>
                    </div>

                    <div className="info-row">
                        <span>Food Type</span>
                        <strong>{food.foodType}</strong>
                    </div>

                    <div className="info-row">
                        <span>Preparation Time</span>
                        <strong>{food.preparationTime} mins</strong>
                    </div>

                    <div className="info-row">
                        <span>Provider</span>
                        <strong>{food.providerId?.businessName || "-"}</strong>
                    </div>

                </div>

                <div className="overview-card">

                    <h3>Pricing</h3>

                    <div className="info-row">
                        <span>Price</span>
                        <strong>₹{food.price}</strong>
                    </div>

                    <div className="info-row">
                        <span>Offer Price</span>
                        <strong>
                            {food.offerPrice
                                ? `₹${food.offerPrice}`
                                : "-"}
                        </strong>
                    </div>

                    <div className="info-row">
                        <span>Discount</span>
                        <strong>
                            {food.discountPercentage || 0}%
                        </strong>
                    </div>

                </div>

                <div className="overview-card">

                    <h3>Availability</h3>

                    <div className="info-row">
                        <span>Status</span>

                        <strong>
                            {food.isAvailable
                                ? "Available"
                                : "Unavailable"}
                        </strong>

                    </div>

                    <div className="info-row">
                        <span>Today's Menu</span>

                        <strong>
                            {food.availableToday
                                ? "Yes"
                                : "No"}
                        </strong>

                    </div>

                    <div className="info-row">
                        <span>Quantity</span>

                        <strong>
                            {food.quantity || "-"} {food.unit || ""}
                        </strong>

                    </div>

                </div>

                <div className="overview-card">

                    <h3>Description</h3>

                    <p className="description">

                        {food.description || "No description available."}

                    </p>

                </div>

            </div>

        </div>
    );
}

export default OverviewTab;